<template>
    <section class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ">
        <div class="max-w-3xl mx-auto">
            <router-view />
        </div>
    </section>
</template>
<script>
export default {
    created: async function() {
        this.$eventBus.$on('RELOAD', async () => { await this.init() })
    },
    destroyed: function () {
        this.$eventBus.$off('RELOAD', async () => { await this.init() })
    },

}
</script>